// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"8f3c7d59","38":"0f2f15a0","62":"f9c68912","80":"93115b96","101":"f6169220","453":"0d63c543","673":"29f77a05"}[chunkId] + ".chunk.js";
};